// accessRegistry.js
export const SIDEBAR_MENU = [
    { key: "zabbix", label: "Zabbix", route: "https://www.jmareports.com/zabbix/index_sso.php", icon: "MonitorHeart" },
    { key: "gitlab", label: "Gitlab", route: "https://172.26.16.10:7990/", icon: "GitHub" },
    {
        key: "kpi_reports",
        label: "KPI Reports",
        icon: "Assessment",
        children: [
            { key: "kpi_su", label: "Syracuse University", intenalRoute: true, route: "/reports/site/su" },
            { key: "kpi_caesars", label: "Caesars NOBU", intenalRoute: true, route: "/reports/site/caesars" },
            { key: "kpi_foa", label: "IPSec FOA", intenalRoute: true, route: "/reports/site/foa" },
            { key: "kpi_mocn_foa", label: "MOCN FOA", intenalRoute: true, route: "/reports/site/5gfactory" },
            { key: "kpi_tmobile_monthly", label: "T-Mobile Monthly", intenalRoute: true, route: "/reports/site/tmo-combined" },
            { key: "kpi_windsor", label: "Windsor", intenalRoute: true, route: "/reports/site/windsor" },
        ]
    },
    {
        key: "kpi_reports_beta",
        label: "KPI Reports (Beta)",
        icon: "Assessment",
        children: [
            { key: "kpi_beta_su", label: "Syracuse University", intenalRoute: true, route: "/reports/beta/su" },
            { key: "kpi_beta_caesars", label: "Caesars NOBU", intenalRoute: true, route: "/reports/beta/caesars" },
            { key: "kpi_beta_foa", label: "IPSec FOA", intenalRoute: true, route: "/reports/beta/foa" },
            { key: "kpi_beta_mocn_foa", label: "MOCN FOA", intenalRoute: true, route: "/reports/beta/mocn-foa" },
            { key: "kpi_beta_windsor", label: "Windsor", intenalRoute: true, route: "/reports/beta/windsor" },
        ]
    },
    {
        key: "alarm_reports",
        label: "Alarm Reports",
        icon: "NotificationsActive",
        children: [
            { key: "all_sites_alarm_reports", label: "All Sites Alarm Reports", intenalRoute: true, route: "/reports/alarm-all" },
            { key: "su_alarm_reports", label: "SU Alarm Reports", intenalRoute: true, route: "/reports/alarm-su" },
            { key: "international_alarm_reports", label: "International Alarm Reports", intenalRoute: true, route: "/reports/alarm-intl" }
        ]
    },
    // {
    //     key: "xran",
    //     label: "XRAN Tracking",
    //     route: "/xran",             // <‑‑ change only this
    //     icon: "Timeline"
    // },
    { key: "xran", label: "XRAN Tracking", intenalRoute: true, route: "/xran-tracking", icon: "Timeline" },
    // { key: "xran", label: "XRAN Tracking", intenalRoute: "true", route: "/xran", icon: "Timeline" },
    // { key: "xran_tracking", label: "XRAN Tracking (Legacy)", intenalRoute: true, route: "/xran-tracking", icon: "Timeline" },
    { key: "keycloak", label: "Keycloak", route: "https://www.jmareports.com/keycloak", icon: "KeyIcon" },
    { key: "userlogin", label: "User Login", intenalRoute: true, route: "/login-tracking", icon: "AccountCircle" },
    { key: "dataRequest", label: "Data Request", intenalRoute: true, route: "/data-request", icon: "Dataset" },
    { key: "outageTracker", label: "Outage Tracker", intenalRoute: true, route: "/outage-tracker", icon: "Block" },
    { key: "nocHardware", label: "NOC Hardware", intenalRoute: true, route: "/noc-hardware", icon: "ListAlt" },
    { key: "xranCerts", label: "xRAN Certificates", intenalRoute: true, route: "/xran-certs", icon: "KeyIcon" },
    { key: "shiftsManagement", label: "NOC Calendar", intenalRoute: true, route: "/shifts", icon: "AccessAlarms" },
    { key: "campusMap", label: "JMA Site Map", intenalRoute: true, route: "/campus-map", icon: "Terrain" },
    { key: "suBuildingData", label: "SU Per Building User Data", intenalRoute: true, route: "/su-building-data", icon: "Apartment" },
    { key: "releaseNotes", label: "Release Notes", intenalRoute: true, route: "/release-notes", icon: "Campaign" }
];

export const FEATURE_REGISTRY = [
    { key: "alarms", label: "Alarms", component: "AlarmCardsContent" },
    { key: "outages", label: "Outages", component: "OutagesContent" },
    { key: "user_counts", label: "User Counts & Data Usage", component: "UserCountsDataUsageContent" }
];

export const GROUP_MATRIX = {
    admin: {
        sidebar: "*",
        features: "*"
    },
    Dashboard: {
        sidebar: ["campusMap", "suBuildingData"],
        features: ["user_counts", "alarms"]
    },
    "C-Suite": {
        sidebar: ["campusMap", "suBuildingData"],
        features: ["user_counts", "outages"]
    },
    VP: {
        sidebar: ["kpi_reports", "kpi_su", "kpi_caesars", "kpi_foa", "kpi_mocn_foa", "kpi_tmobile_monthly", "kpi_windsor", "alarm_reports", "all_sites_alarm_reports", "su_alarm_reports", "international_alarm_reports", "zabbix", "dataRequest", "xran", "xranCerts", "campusMap", "suBuildingData"],
        features: ["user_counts", "alarms", "outages"]
    },
    Executive: {
        sidebar: ["zabbix", "campusMap", "suBuildingData"],
        features: ["user_counts", "outages"]
    },
    Manager: {
        sidebar: ["zabbix", "xran", "kpi_reports", "kpi_su", "kpi_caesars", "kpi_foa", "kpi_mocn_foa", "kpi_tmobile_monthly", "kpi_windsor", "alarm_reports", "all_sites_alarm_reports", "su_alarm_reports", "international_alarm_reports", "dataRequest", "campusMap", "suBuildingData"],
        // sidebarDeny: ["gitlab", "approve_reports"],
        features: "*"
    },
    NOC: {
        sidebar: ["outageTracker", "zabbix", "shiftsManagement", "kpi_reports", "kpi_su", "kpi_caesars", "kpi_foa", "kpi_mocn_foa", "kpi_tmobile_monthly", "kpi_windsor", "alarm_reports", "all_sites_alarm_reports", "su_alarm_reports", "international_alarm_reports", "dataRequest", "xran", "xranCerts", "campusMap", "suBuildingData"],
        // sidebarDeny: ["gitlab", "approve_reports"],
        features: "*"
    },
    Pierson: {
        sidebar: ["kpi_reports", "kpi_windsor", "campusMap", "suBuildingData"]
    },
    "T-Mobile": {
        sidebar: ["kpi_reports", "kpi_su", "kpi_caesars", "kpi_foa", "kpi_mocn_foa", "kpi_tmobile_monthly", "kpi_windsor", "campusMap", "suBuildingData"]
    },
    "AT&T": {
        sidebar: ["kpi_reports", "kpi_su", "kpi_caesars", "kpi_foa", "kpi_mocn_foa", "kpi_tmobile_monthly", "kpi_windsor", "campusMap", "suBuildingData"]
    },
    "Construction": {
        sidebar: ["kpi_reports", "kpi_su", "kpi_caesars", "kpi_foa", "kpi_mocn_foa", "kpi_tmobile_monthly", "kpi_windsor", "alarm_reports", "all_sites_alarm_reports", "su_alarm_reports", "international_alarm_reports", "dataRequest", "xran", "campusMap", "suBuildingData"],
        features: ["user_counts", "alarms"]
    },
};
